import axios, { AxiosError, CreateAxiosDefaults } from "axios";
import axiosRetry from "axios-retry";

export const baseURL =
  `${process.env.REACT_APP_API_URL}/graphql2` ||
  `${process.env.API_URL}/graphql2`;

type Headers = CreateAxiosDefaults<any>["headers"];

export const getClient = async (headers?: Headers, timeout = 5 * 60 * 1000) => {
  const client = axios.create({ baseURL, timeout, headers });

  axiosRetry(client, {
    retries: 5, // Up to 5 additional tries (6 total)
    retryDelay: (retryCount) => {
      console.log(`Retry attempt: ${retryCount}`);
      return 12 * 1000; // 12 seconds delay
    },
    retryCondition: (error) => {
      // Retry on network errors or any retryable conditions
      return (
        axiosRetry.isNetworkError(error) || axiosRetry.isRetryableError(error)
      );
    },
  });

  return client;
};
